export default "__VITE_ASSET__BvfU1tLY__"